export default __webpack_public_path__ + "static/media/weights2.af75a5c2.png";